<template>
  <div class="card-body">
    <h4 class="text-muted text-center">
      Regra de Conexão
    </h4>

    <v-text-field label="MAC"
                  name="MAC"
                  v-model="val.mac"
                  v-validate="'required'"
                  :error-messages="errors.collect('MAC')"
                  mask="NN:NN:NN:NN:NN:NN"
                  @input="$emit('input', val)"
                  return-masked-value></v-text-field>

    <v-text-field label="Descrição"
                  name="Descrição"
                  v-model="val.descricao"
                  v-validate="'required'"
                  :error-messages="errors.collect('Descrição')"
                  @input="$emit('input', val)"></v-text-field>

  </div>
</template>

<script>
    import vModel from '@mixins/v-model'
    import EventBus from '@packages/event-bus'

    export default {
        components: {
        },

        props: {

        },

        computed: {

        },

        methods: {
            reset() {
                this.$validator.reset()
            },

            async validate() {
                await this.$validator.validateAll()

                if (this.$validator.errors.items.length !== 0)
                    return this.$emit('to-general-tab')

                this.$emit('valid')
            },
        },

        mixins: [vModel],

        mounted() {
            EventBus.$on('RESET_FREECONNECTIONS_MODAL', this.reset)
        },

        beforeDestroy() {
            EventBus.$off('RESET_FREECONNECTIONS_MODAL', this.reset)
        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.card-body {
  padding: 18px 50px 10px;

  .v-input {
    margin: 12px 0 10px 0;
  }

  .dates {
    display: flex;
    margin-bottom: 32px;

    .date {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1 0 auto;

      .datepicker-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 175px;
        height: 55px;
        padding: 0 15px;
        border: $border-1;
        border-radius: 4px;
        font-weight: bold;
        color: $grey-4;

        .mdi {
          font-size: 24px;
        }

        input {
          color: $grey-4;
        }
      }
    }
  }

  .segment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    & > *:not(:first-child) {
      margin-top: 10px;
    }
  }
}
</style>
